import './webview_modal.css'
import useWindowDimensions from "../utils/windowDimensions";

const WebviewModal = ({ handleClose, show, children , title }) => {
    const showHideClassName = show ? "modal display-block" : "modal display-none";
    const { height, width } = useWindowDimensions();
    return (
        <div style={{height: height}} className={showHideClassName}>
            <section className="modal-main">
                {children}
            </section>
        </div>
    );
};

export default  WebviewModal;